/**
 * Generated by orval 🍺
 * Do not edit manually.
 * QPM API
 * OpenAPI spec version: 0.1.0
 */
import {
  useQuery
} from '@tanstack/react-query';
import type {
  QueryFunction,
  QueryKey,
  UseQueryOptions,
  UseQueryResult
} from '@tanstack/react-query';

import type {
  Sector
} from '../../models';

import { customMutator } from '../../api.ts';

type AwaitedInput<T> = PromiseLike<T> | T;

      type Awaited<O> = O extends AwaitedInput<infer T> ? T : never;


type SecondParameter<T extends (...args: never) => unknown> = Parameters<T>[1];



const withQueryKey = <T extends object, K>(query: T, queryKey: K): T & { queryKey: K } => {
  const result = { queryKey } as T & { queryKey: K };
  for (const key of Object.keys(query)) {
    // The explicit queryKey always wins, matching the previous
    // `{ ...query, queryKey }` spread where it was set last.
    if (key === 'queryKey') continue;
    Object.defineProperty(result, key, {
      enumerable: true,
      configurable: true,
      get: () => (query as Record<string, unknown>)[key],
    });
  }
  return result;
};

/**
 * Returns list of unique GICS sectors.
 * @summary Sectors
 */
export const sectors = (

 options?: SecondParameter<typeof customMutator>,signal?: AbortSignal
) => {


      return customMutator<Sector[]>(
      {url: `/securities/classification/sectors`, method: 'GET', signal
    },
      options);
    }




export const getSectorsQueryKey = () => {
    return [
    `/securities/classification/sectors`
    ] as const;
    }


export const getSectorsQueryOptions = <TData = Awaited<ReturnType<typeof sectors>>, TError = unknown>( options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof sectors>>, TError, TData>, request?: SecondParameter<typeof customMutator>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getSectorsQueryKey();



    const queryFn: QueryFunction<Awaited<ReturnType<typeof sectors>>> = ({ signal }) => sectors(requestOptions, signal);





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof sectors>>, TError, TData> & { queryKey: QueryKey }
}

export type SectorsQueryResult = NonNullable<Awaited<ReturnType<typeof sectors>>>
export type SectorsQueryError = unknown


/**
 * @summary Sectors
 */

export function useSectors<TData = Awaited<ReturnType<typeof sectors>>, TError = unknown>(
  options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof sectors>>, TError, TData>, request?: SecondParameter<typeof customMutator>}

 ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } {

  const queryOptions = getSectorsQueryOptions(options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  return withQueryKey(query, queryOptions.queryKey);
}






